import React, {Component} from "react";
import {categories, categoryLabels} from "./Controls";

interface NavProps {
    active: boolean
    category: string
    count: number
    onClick?: (category: string) => void
}

interface NavState {
    count: number
}

export class D3NumberNav extends Component<NavProps, NavState> {

    constructor(props: NavProps) {
        super(props);
        this.state = {
            count: this.props.count
        };
    }

    static getDerivedStateFromProps(props: NavProps, state: NavState) {
        const nextState: Partial<NavState> = {};
        if (props.count !== state.count) {
            nextState.count = props.count;
        }
        return nextState;
    }

    handleClick = () => {
        if (this.props.onClick) {
            this.props.onClick(this.props.category);
        }
    };

    render() {
        return (
            <div className={`col d3NumberNav ${this.props.category} ${this.props.active && this.props.category !== categories.GRAND_TOTAL ? "active": ""}`} onClick={this.handleClick}>
                <div className="d3NavContainer">
                    <div className="label">{ categoryLabels[this.props.category] }</div>
                    <div className="d3NumberNavTotal">{this.state.count}</div>
                </div>
            </div>
        );
    }
}
